import Hero from '../components/Hero'
import Stats from '../components/Stats'
import ServicesPreview from '../components/ServicesPreview'
import AboutPreview from '../components/AboutPreview'
import ContactForm from '../components/ContactForm'

const Home = () => {
  return (
    <div className="pt-16 overflow-hidden">
      <Hero />
      <Stats />
      <AboutPreview />
      <ServicesPreview />
      <ContactForm />
    </div>
  )
}

export default Home
